module.exports = __webpack_public_path__ + "hero-slide-2.1b0bd55a44e53ba06bc3.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/IsaGul/Desktop/beyn-projects/commercial-front-end/src/assets/images/soccer/samples/hero-slide-2.jpg
// module id = ../../../../../src/assets/images/soccer/samples/hero-slide-2.jpg
// module chunks = styles